var map = {
	"./Agricultural Products.webp": 34547,
	"./Apparel and Textiles.webp": 33653,
	"./Automotive.webp": 3118,
	"./Baby Products.webp": 70585,
	"./Beauty and Personal Care.webp": 15651,
	"./Books Media and Entertainment.webp": 44864,
	"./Chemicals and Allied Products.webp": 98900,
	"./Clothing and Apparel.webp": 1723,
	"./Consumer Goods.webp": 54689,
	"./Customer Service and Support.webp": 34654,
	"./Data Management and Analytics.webp": 85827,
	"./E-commerce.webp": 32102,
	"./Education Services.webp": 80525,
	"./Education and Training.webp": 77668,
	"./Electronics and Appliances.webp": 27325,
	"./Entertainment and Media Services.webp": 69090,
	"./Environmental Services.webp": 41791,
	"./Environmental and Regulatory Compliance.webp": 55885,
	"./Fashion and Apparel.webp": 22109,
	"./Financial Management.webp": 43197,
	"./Financial Services.webp": 6210,
	"./Food and Beverages.webp": 36972,
	"./Furniture and Fixtures.webp": 62948,
	"./Health and Pharmaceuticals.webp": 10534,
	"./Healthcare Services.webp": 98660,
	"./Home and Garden.webp": 29693,
	"./Home and Kitchen Essentials.webp": 55142,
	"./Hospitality and Tourism Services.webp": 74877,
	"./Human Resources and Staffing Services.webp": 93118,
	"./Industrial and Manufacturing Supplies.webp": 87462,
	"./Information Technology Services.webp": 14889,
	"./Inventory Management.webp": 84612,
	"./Legal Services.webp": 6832,
	"./Luxury Goods.webp": 62636,
	"./Maintenance and Repair Services.webp": 26252,
	"./Office Supplies and Equipment.webp": 94547,
	"./Packaging and Containers.webp": 96029,
	"./Personal Accessories.webp": 68069,
	"./Personal Care and Hygiene.webp": 35546,
	"./Pet Supplies.webp": 15227,
	"./Production Processes.webp": 87377,
	"./Professional Services.webp": 18004,
	"./Quality Control and Assurance.webp": 4017,
	"./Raw Materials and Supply Chain Management.webp": 23265,
	"./Real Estate Services 2.webp": 31077,
	"./Real Estate Services 3.webp": 9978,
	"./Real Estate Services.webp": 45411,
	"./Research and Development (R&D).webp": 22309,
	"./Safety and Risk Management.webp": 79358,
	"./Sales and Marketing.webp": 39380,
	"./Sporting Goods and Outdoor Equipment.webp": 40938,
	"./Supply Chain and Logistics.webp": 26607,
	"./Sustainability Initiatives.webp": 63993,
	"./Technology and Electronics.webp": 80271,
	"./Technology and Equipment.webp": 9092,
	"./Toys and Games.webp": 74564,
	"./Transportation and Logistics Services.webp": 26925,
	"./Travel and Leisure.webp": 53701,
	"./Utility Services.webp": 51959,
	"./Wholesale.webp": 13505,
	"./Workforce.webp": 26097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97645;